export default __webpack_public_path__ + "static/media/gallery-wip-pommel_04.c53d4971.jpg";